import React from "react";
import { Wrapper } from "./doubleRepayments.styles";
import { formatMoney } from "../../../../../utils/helpers/stringHelper";
import { useAccount } from "../../../../../hooks/client";
import { ManageRepaymentForm } from "../../../components/manageRepaymentForm";
import { Wrapper as ModalWrapper } from "./../../../components/manageMyRepaymentModal/manageMyRepaymentModal.styles";
import { getDoubleNextPaymentEndpoint } from "../../../../../services/apiRoutes";
import { withLoanForm } from "../../../../../components/fairGoForm/withLoanForm";
import { Wrapper as FormWrapper } from "./increaseRepaymentsForms.styles";
import { useLocation, useRouteMatch } from "react-router";
import { MANAGE_REPAYMENTS_INCREASE_ROUTE, MANAGE_ARREARS_ROUTE } from "../route.constants";

const ModalMessage = () => {
  return (
    <ModalWrapper>
      <h3>Thank You</h3>
      <p>
        Your request to double your repayments has been submitted and actioned.
      </p>
    </ModalWrapper>
  );
};

export const _DoubleRepaymentsForm = ({ accountId }) => {
  const activeAccount = useAccount(accountId) || {};
  const currentRepayment = formatMoney(activeAccount.nextPaymentAmount, {
    removeZeroCents: false,
  });
  const nextPaymentDate = activeAccount.nextPaymentDate;
  const doublePaymentAmount = formatMoney(activeAccount.nextPaymentAmount * 2, {
    removeZeroCents: false,
  });

  return (
    <Wrapper>
      <h3 className="double-repayment-title">
        You will be paying an extra {currentRepayment} on your next repayment.
      </h3>
      <div className="repayment-infomation">
        <p>Next Repayment Date</p>
        <h3>
          {nextPaymentDate.day}/{nextPaymentDate.month}/{nextPaymentDate.year}
        </h3>
      </div>
      <div className="repayment-infomation">
        <p>Next Repayment Amount</p>
        <h3>{doublePaymentAmount}</h3>
      </div>
    </Wrapper>
  );
};

const DoubleRepaymentsForm = withLoanForm(_DoubleRepaymentsForm);

export const DoubleRepayments = ({ accountId }) => {
  const { path } = useRouteMatch();
  const matchIncreaseRepayment = path + MANAGE_REPAYMENTS_INCREASE_ROUTE.INCREASE_DOUBLE;
  const matchManageArrears = path + MANAGE_ARREARS_ROUTE.PAY_DOUBLE;
  const { pathname } = useLocation();
  const isActive = matchIncreaseRepayment === pathname || matchManageArrears === pathname;

  return (
    <FormWrapper>
      <ManageRepaymentForm
        buttonText="I Agree And Confirm My Request"
        endpoint={getDoubleNextPaymentEndpoint(accountId)}
        initialValues=""
        modalMessage={<ModalMessage />}
        isActive={isActive}
      >
        <DoubleRepaymentsForm accountId={accountId} />
      </ManageRepaymentForm>
    </FormWrapper>
  );
};